export class Reg {
axaDOB: string;
email: string;
policyInd: string;
policyNum: string;
axassn: string;
ssnPasteEvent: string;
sessionId: string;

}
